// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  index(context, params) {
    const { sortBy, descending, page, rowsPerPage } = params.pagination
      ? params.pagination
      : [null, null, null, null];

    const fields = params.fields ? params.fields : "";
    const expand = params.expand ? params.expand : "";

    let body = {
      page: page,
      sortBy: sortBy,
      descending: descending,
      rowsPerPage: rowsPerPage,
      search: params.search,
      fields: fields,
      expand: expand
    };

    if (params.filters) {
      for (let fIdx = 0; fIdx < params.filters.length; fIdx++) {
        const filter = params.filters[fIdx];
        let f = "filter";
        for (let index = 0; index < filter.length - 1; index++) {
          const element = filter[index];
          f += "[" + element + "]";
        }
        //f += "="+filter[filter.length-1];
        body[f] = filter[filter.length - 1];
      }
    }
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("order-comment/" + params.orderId, body)
        .then(({ data }) => {
          context.commit("set_orders", data);
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },

  create(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.post("order-comment/" + params.orderId, params)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  
};
